/**
 * @fileoverview Componente responsável por isolar falhas de renderização e evitar que a interface inteira quebre.
 */

import React from "react";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] UI crash capturado:", error, info);
    toast.error("Ocorreu um erro na interface. Atualize a página ou tente novamente.");
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || <div style={{ padding: 16, color: "#fff" }}>Algo deu errado.</div>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
